import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { TransformermaintainanceComponent } from '../transformermaintainance.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-maintainanceplanning',
  templateUrl: './maintainanceplanning.component.html',
  styleUrls: ['./maintainanceplanning.component.scss']
})
export class MaintainanceplanningComponent implements OnInit {
  @ViewChild(MatPaginator,{static:true}) paginator!: MatPaginator;
  modelHtml: string = '';
  displayedColumns = ['sitename','transformerid','date','engineername','downtime','estimatedcost','status','actions'];
  roleID;
  dataSource;
  loginUserData= JSON.parse(localStorage.getItem("userData"));
  constructor(private dialog: MatDialog,private transMngSer:TransformerManagerService) { }

  ngOnInit() {
   this.getData();
  }
addMaintainancePlanning(action,data){
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = false;
  dialogConfig.autoFocus = true;
  dialogConfig.width = '80%';
  if(action == 'add'){
    dialogConfig.data = [];
  } else {
    dialogConfig.data = data;
  }
  let dialogRef = this.dialog.open(TransformermaintainanceComponent, dialogConfig);
  dialogRef.afterClosed().subscribe(result => {
    this.getData(); 
});
}
getData(){
  this.transMngSer.getMaintenancePlanningData({"userid":this.loginUserData.userid}).toPromise().then((response: any) => {
    if(response.code ==1)
    {
       console.log("adsddas",response)
      this.dataSource = new MatTableDataSource(response.data);
      this.dataSource.paginator = this.paginator;
    }
  });
}

deleteData(data){

  Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to delete this item? This action cannot be undone!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel'
  }).then((result) => {
    if (result.isConfirmed) {
      // Call your delete function here
      this.performDelete(data);
      Swal.fire('Deleted!', 'Your item has been deleted.', 'success');
    }
  });
}
performDelete(data){
  this.transMngSer.deleteMaintenancePlanningData({"id":data.id}).toPromise().then((response: any) => {
    if(response.code ==1)
    {
      this.getData(); 
    }
  });
}
public doFilter = (value: string) => {
  this.dataSource.filter = value.trim().toLocaleLowerCase();
}
}